export default __webpack_public_path__ + "static/media/Snd43.ff4183fe.mp3";